module.exports = __webpack_public_path__ + "img/logo-bisnis-com.0e2cc6b3.png";